export default function ArrowCheck({
  color = "#7B76FF",
  strokeWidth = 1,
  width = 32,
  height = 32,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <path
        d="M28.001 7.49939C28.3988 7.4995 28.7802 7.65758 29.0615 7.93884C29.3429 8.22025 29.501 8.60239 29.501 9.00037C29.5009 9.39819 29.3428 9.7796 29.0615 10.0609L13.0615 26.0609C12.9223 26.2002 12.7571 26.3107 12.5752 26.3861C12.3932 26.4615 12.198 26.5003 12.001 26.5004C11.8039 26.5004 11.6079 26.4616 11.4258 26.3861C11.2894 26.3295 11.1625 26.2529 11.0488 26.1595L10.9395 26.0609L3.93945 19.0609C3.65819 18.7796 3.50011 18.3982 3.5 18.0004C3.5 17.6024 3.65804 17.2203 3.93945 16.9388C4.22086 16.6574 4.603 16.4994 5.00098 16.4994C5.39877 16.4995 5.78022 16.6576 6.06152 16.9388L12.001 22.8783L26.9395 7.93884C27.2209 7.65743 27.603 7.49939 28.001 7.49939Z"
        fill={color}
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
